import { getDistance } from "geolib";

import {
  fallbackLocation,
  GEOLOCATION_MAX_AGE_MS,
  GEOLOCATION_TIMEOUT_MS,
} from "./constants";

const USER_LOCATION_SESSION_KEY = "hotple-user-location";

export const normalizeLocation = (location) => {
  const latitude = Number(location?.latitude);
  const longitude = Number(location?.longitude);

  if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return null;
  return { latitude, longitude };
};

export const getStoredUserLocation = () => {
  if (typeof window === "undefined") return null;

  try {
    return normalizeLocation(
      JSON.parse(sessionStorage.getItem(USER_LOCATION_SESSION_KEY) || "null")
    );
  } catch (_) {
    return null;
  }
};

export const persistUserLocation = (location) => {
  if (typeof window === "undefined") return;

  try {
    sessionStorage.setItem(USER_LOCATION_SESSION_KEY, JSON.stringify(location));
  } catch (_) {
    // Session storage can be unavailable in restricted browser contexts.
  }
};

export const isNearbyLocation = (left, right, meters = 30) => {
  const normalizedLeft = normalizeLocation(left);
  const normalizedRight = normalizeLocation(right);

  if (!normalizedLeft || !normalizedRight) return false;
  return getDistance(normalizedLeft, normalizedRight) <= meters;
};

export const resolveInitialUserLocation = () => {
  const storedLocation = getStoredUserLocation();

  return {
    initialLocation: storedLocation || fallbackLocation,
    shouldPersistInitialLocation: Boolean(storedLocation),
  };
};

export const getBrowserUserLocation = () => {
  if (!navigator.geolocation) {
    return Promise.reject(new Error("Browser does not support Geolocation."));
  }

  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      (position) => resolve(position),
      (error) => reject(new Error(error?.message)),
      {
        enableHighAccuracy: false,
        timeout: GEOLOCATION_TIMEOUT_MS,
        maximumAge: GEOLOCATION_MAX_AGE_MS,
      }
    );
  });
};
